<template>
    <el-dialog title="合同信息" :visible="dialog_visible" center :before-close="handleCloseDialog" :z-index="2000">
        <el-form size="small" :model="form" ref="form" :rules="rules"  label-width="120px" class="invoice-ruleForm">
            <template v-if="show_type == 'create' || show_type == 'supplement'">
                <el-form-item label="合同类型" prop="type">
                    <el-select v-model="form.type" placeholder="请选择合同类型" multiple>
                        <el-option v-for="(contract, index) in contract_types" :label="contract.label" :value="contract.value" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="要求处理时间" prop="handle_at">
                    <el-date-picker
                    format="yyyy-M-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    v-model="form.handle_at"
                    placeholder="请选择处理时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="对应订单ID" prop="order_id" v-if="show_type != 'supplement'">
                    <el-input type="number" placeholder="对应订单ID" v-model="form.order_id" @blur="getContractNumberByOrderId"></el-input>
                </el-form-item>
                <el-form-item prop="is_logistic">
                    <el-checkbox v-model="form.is_logistic">需要寄件</el-checkbox>
                </el-form-item>
                <template v-if="form.is_logistic">
                    <el-form-item label="寄出日期" prop="send_at">
                        <el-date-picker
                        format="yyyy-M-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        v-model="form.send_at"
                        placeholder="选择寄出日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="寄件方式：" prop="send_type">
                        <el-radio-group v-model="form.send_type">
                            <el-radio :label="1">快递</el-radio>
                            <el-radio :label="2">邮件（请备注邮箱）</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="form.send_type == 1"  label="寄件快递：" prop="send_way">
                        <el-select v-model="form.send_way" placeholder="请选择送达方式" multiple clearable>
                            <el-option label="德邦快递" value="1"></el-option>
                            <el-option label="中通快递" value="2"></el-option>
                            <el-option label="圆通快递" value="3"></el-option>
                            <el-option label="顺丰快递" value="4"></el-option>
                            <el-option label="韵达快递" value="5"></el-option>
                            <el-option label="邮政快递" value="6"></el-option>
                            <el-option label="其他" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="收货地址：" prop="express_id">
                        <OrderAddress 
                            :key="order_address_key"
                            :order_id="form.order_id" 
                            @change="handleAddressSelect"
                            :express_id="form.express_id"
                            :enableOrderIdCheck="show_type != 'supplement'">
                        </OrderAddress>
                        <el-button 
                            size="mini" 
                            type="text" 
                            :disabled="!form.order_id"
                            @click="dialogExpressTable">+新增地址</el-button>
                    </el-form-item>
                    <el-form-item label="寄件备注：" prop="express_content">
                        <el-input v-model="form.express_content" autocomplete="off"></el-input>
                    </el-form-item>
                </template>
             
            </template>
            <template v-if="show_type == 'create' || show_type == 'update'">
                <el-form-item label="合同编号" prop="code">
                    <el-input placeholder="请输入合同编号" v-model="form.code" :disabled="codeFromApi || (show_type == 'update' && !!params.code)"></el-input>
                </el-form-item>
                <el-form-item label="是否处理" prop="is_handle">
                    <el-switch v-model="form.is_handle" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>
            </template>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">关闭</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="loading">保存</el-button>
        </div>
        
        <!-- 地址信息弹框 -->
        <el-dialog 
            title="地址信息" 
            :visible.sync="dialogExpressVisible" 
            width="650px" 
            center 
            :close-on-click-modal="false" 
            :before-close="handleCloseAddressDialog"
            append-to-body
            :z-index="4000">
            <el-form :model="newAddress" ref="addressForm" :rules="addressRules" class="demo-ruleForm">
                <el-form-item label="收件人姓名" label-width="100px" prop="name">
                    <el-input v-model="newAddress.name" auto-complete="off" placeholder="请输入收件人姓名"></el-input>
                </el-form-item>
                <el-form-item label="联系方式" label-width="100px" prop="mobile">
                    <el-input v-model="newAddress.mobile" auto-complete="off" placeholder="请输入联系方式"></el-input>
                </el-form-item>
                <DistrictLinkage 
                    :itemLabelWidth="'100px'" 
                    :provinceId="newAddress.province_id"  
                    :cityId="newAddress.city_id" 
                    :districtId="newAddress.district"  
                    @change="handleAddressChange">
                </DistrictLinkage>
                <el-form-item label="地址" label-width="100px" prop="address">
                    <el-input v-model="newAddress.address" auto-complete="off" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item label="邮寄方式" label-width="100px" prop="express_company">
                    <el-select v-model="newAddress.express_company" placeholder="请选择">
                        <el-option v-for="item in expressOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注信息" label-width="100px">
                    <el-input v-model="newAddress.memo" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseAddressDialog">关闭</el-button>
                <el-button type="primary" @click="handleSubmitAddress" :loading="addressLoading">保存</el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>
<script>
import OrderContractSealService from "~/services/OrderContractSeal";
import http from "~/common/http";
import OrderAddress from "~/widgets/OrderAddress.vue";
import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
import OrderExpressService from "~/services/OrderExpress";
export default {
    props:{
        dialog_visible: false,
        params: null,
        show_type: '',
    },
    components:{
        OrderAddress,
        DistrictLinkage,
    },

    data() {
        return {
            // dialog_visible: false,
            form: {
                is_logistic: false,
                is_handle: 0,
                code: '',
                type: [],
                send_way: [],
                order_id: '',
                express_id: ''
            },
            // 地址弹框相关
            dialogExpressVisible: false,
            newAddress: {
                name: '',
                mobile: '',
                address: '',
                memo: '',
                express_company: '',
                province_id: 0,
                city_id: 0,
                district: 0,
                label_name: ''
            },
            addressRules: {
                name: [
                    {required: true, message: '请输入收件人姓名', trigger: 'blur'}
                ],
                mobile: [
                    {required: true, message: '请输入联系方式', trigger: 'blur'}
                ],
                address: [
                    {required: true, message: '请输入详细地址', trigger: 'blur'}
                ],
                express_company: [
                    {required: true, message: '请选择邮寄方式', trigger: 'change'}
                ]
            },
            addressLoading: false,
            expressOptions: [],
            order_address_key: 0,
            codeFromApi: false, // 标记合同编号是否来自接口
            rules: {
                type: [
                    {required: true, message: "请选择合同类型", trigger: "change"}
                ],
                handle_at: [
                    {required: true, message: "请选择合同处理时间", trigger: "change"}
                ],
                send_at: [
                    {required: true, message: '请填选寄出日期', trigger: 'change'},
                ],
                send_type: [
                    {required: true, message: '请填选送达方式', trigger: 'change'},
                ],
                send_way: [
                    {required: true, message: '请选择寄件快递', trigger: 'change'},
                ],
                order_id: [
                    {required: true,message: "请填写对应订单ID",trigger: "blur"}
                ],
                express_id: [
                    {required: true, message: '请选择收货地址', trigger: 'change'}
                ],
            },
            formLabelWidth: '100px',
            contract_types: OrderContractSealService.contractTypes(false),
            loading: false
        };
    },
    created() {
        this.form = Object.assign(this.form, this.params);
        // 初始化邮寄方式选项
        this.expressOptions = [
            {label: '德邦快递', value: '1'},
            {label: '中通快递', value: '2'},
            {label: '圆通快递', value: '3'},
            {label: '顺丰快递', value: '4'},
            {label: '韵达快递', value: '5'},
            {label: '邮政快递', value: '6'},
            {label: '其他', value: '0'}
        ];
    },

    /**
     * 监听组件切换变化
     */
    watch: {
        params: function (value, oldValue) {
            // this.form =  value;
            this.form = Object.assign(this.form, value);
        },
    },
    methods:{
        // 获取订单ID
        getOrderId() {
            return this.form.order_id || (this.params && this.params.order_id) || this.$route.query.id;
        },
        
        // 处理地址选择
        handleAddressSelect(value) {
            this.form.express_id = value;
        },
        
        // 打开地址弹框
        dialogExpressTable() {
            this.$nextTick(() => {
                this.dialogExpressVisible = false;
                this.$nextTick(() => {
                    this.dialogExpressVisible = true;
                });
            });
        },
        
        // 关闭地址弹框
        handleCloseAddressDialog() {
            this.dialogExpressVisible = false;
            this.$nextTick(() => {
                this.$refs.addressForm && this.$refs.addressForm.resetFields();
                this.newAddress = {
                    name: '',
                    mobile: '',
                    province_id: '',
                    city_id: '',
                    district: '',
                    address: '',
                    express_type: '',
                    express_company: '',
                    memo: ''
                };
            });
        },
        
        // 处理地区选择变化
        handleAddressChange(value) {
            if (value && value.length >= 3) {
                this.newAddress.province_id = value[0] || 0;
                this.newAddress.city_id = value[1] || 0;
                this.newAddress.district = value[2] || 0;
            } else {
                this.newAddress.province_id = 0;
                this.newAddress.city_id = 0;
                this.newAddress.district = 0;
            }
        },
        
        // 提交新地址
        handleSubmitAddress() {
            // 检查地区是否已选择
            if (!this.newAddress.province_id || !this.newAddress.city_id || !this.newAddress.district) {
                this.$message.error('请选择完整的所在地区');
                return;
            }
            
            this.$refs.addressForm.validate((valid) => {
                if (valid) {
                    this.addressLoading = true;
                    let addressData = {
                        ...this.newAddress,
                        order_id: this.getOrderId()
                    };
                    
                    OrderExpressService.create(addressData).then(res => {
                        if (res.code === 0) {
                            this.$message.success('地址添加成功');
                            // 设置新添加的地址为选中状态
                            this.form.express_id = res.data.id;
                            // 刷新地址组件
                            this.order_address_key++;
                            // 发出地址添加成功事件，通知父组件刷新地址列表
                            this.$emit('address-added', res.data);
                            // 关闭弹框
                            this.handleCloseAddressDialog();
                        } else {
                            this.$message.error(res.msg || '地址添加失败');
                        }
                        this.addressLoading = false;
                    }).catch(err => {
                        console.error('地址添加失败:', err);
                        this.$message.error('地址添加失败');
                        this.addressLoading = false;
                    });
                } else {
                    this.$message.error('请填写完整的地址信息');
                }
            });
        },
        
        // 根据订单ID获取合同编号
        getContractNumberByOrderId() {
            if (!this.form.order_id) {
                // 如果订单ID为空，清空合同编号并允许手动输入
                this.form.code = '';
                this.form.express_id = '';
                this.codeFromApi = false;
                return;
            }
            
            // 同时调用两个接口
            Promise.all([
                // 获取合同编号
                http.get('/api/order/get-contract-number-by-order-id', {
                    params: {
                        order_id: this.form.order_id
                    }
                }),
                // 获取订单地址
                http.get('/api/common/get-order-address', {
                    params: {
                        order_id: this.form.order_id
                    }
                })
            ]).then(([contractRes, addressRes]) => {
                // 处理合同编号
                if (contractRes.data) {
                    this.form.code = contractRes.data;
                    this.codeFromApi = true;
                } else {
                    this.form.code = '';
                    this.codeFromApi = false;
                }
                
                // 处理地址数据
                if (addressRes.data && addressRes.data.length > 0) {
                    // 如果有地址数据，选择第一个地址
                    this.form.express_id = addressRes.data[0].id;
                    // 刷新地址组件以显示选中的地址
                    this.order_address_key++;
                } else {
                    this.form.express_id = '';
                }
            }).catch(err => {
                console.error('获取订单信息失败:', err);
                // 请求失败时清空数据并允许手动输入
                this.form.code = '';
                this.form.express_id = '';
                this.codeFromApi = false;
            });
        },

        handleSubmit(){
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.loading = true;
                    if (this.form.id > 0){
                        OrderContractSealService.update(this.form).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    message:'编辑成功',
                                    type:'success'
                                });
                                this.$emit("submit");
                                this.resetFields();
                            }
                            this.loading = false;
                        }).catch((err) => {
                            console.error(err);
                            this.loading = false;
                        });
                    }else{
                        OrderContractSealService.create(this.form).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    message:'创建成功',
                                    type:'success'
                                });
                                this.$emit("submit");
                                this.resetFields();
                            }
                            this.loading = false;
                        }).catch((err) => {
                            console.error(err);
                            this.loading = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        },

        resetFields(){
            this.$refs['form'].resetFields();
            this.form = {
                is_logistic: false,
                is_handle: 0,
                code: '',
                type: [],
                send_way: [],
                order_id: '',
                express_id: ''
            };
            this.codeFromApi = false; // 重置时允许手动编辑合同编号
            // 重置地址相关数据
            this.dialogExpressVisible = false;
            this.order_address_key = 0;
            this.newAddress = {
                name: '',
                mobile: '',
                province_id: 0,
                city_id: 0,
                district: 0,
                address: '',
                express_type: '',
                express_company: '',
                memo: ''
            };
        },

        handleCloseDialog(){
            // this.dialog_visible = false;
            this.resetFields();
            this.$emit("close");
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/dialog/contractSealForm.vue